import { Cross } from '@components/icons'
import { useUI } from '@components/ui'
import AlertRibbon from '@components/ui/AlertRibbon'
import { NavbarSkeleton } from '@components/utils/skeleton/navbar.skeleton'
import { openLoginView } from '@framework/utils/app-util'
import Link from 'next/link'
import { useRouter } from 'next/router'
import NavbarMenu from './NavbarMenu'
import { IDeviceInfo } from '@components/ui/context'
import NavbarTabView from './NavbarTabView'
import { hamburgerMenu, userProfileGAEvent } from '../Navbar/eventsHelper'
import { useEffect, useState } from 'react'

interface IProps {
  hydrationState: boolean
  deviceInfo: IDeviceInfo
  handleClick: () => void
  setIsOpen: (val: boolean) => void
  isOpen: boolean
  config: Array<any>
  setOpenState: (val: number) => void
  openState: number
  previousPath: string
  keywords: any
  accountDropdownConfig: Array<any>
  wishListItemsInCart: number | undefined
  itemsInCart: number
  active: boolean
  showHeaderOnMobile: boolean
}

const NavbarView = (props: IProps) => {
  const {
    hydrationState,
    deviceInfo,
    handleClick,
    setIsOpen,
    isOpen,
    config,
    setOpenState,
    openState,
    previousPath,
    keywords,
    accountDropdownConfig,
    wishListItemsInCart,
    itemsInCart,
    active,
    showHeaderOnMobile,
  } = props

  const {
    isGuestUser,
    user,
    openCart,
    displayAlert,
    setSidebarView,
    setAppliedFilters,
  } = useUI()

  const { asPath } = useRouter()

  const { isMobile, isIPadorTablet } = deviceInfo

  const hydrationStateStyle = {
    margin: '0px 20px -12px 3px',
  }
  const [isVisible,setIsVisible] = useState(true)
  const [lastScrollY,setLastScrollY] = useState(0);
  const handleScroll = ()=>{
    const currentScroll = window.scrollY;
    if(currentScroll > lastScrollY)
    {
      setIsVisible(false)
    }
    else{
      setIsVisible(true)
    }
    setLastScrollY(currentScroll);
  }
  useEffect(() => {
    window.scrollTo(0, 0);
}, []); 
  useEffect(()=>{
    window.addEventListener('scroll',handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  },[lastScrollY])
  return (
    <div 
      className={isMobile
        ?`${lastScrollY === 0 ? '':`${isVisible?'visible':'hideout'}`} sticky top-0 z-50 bg-white closeMobileNav ${!hydrationState ? 'hydrationStateStyle-desktop' : ''}`
        :`sticky top-0 z-50 bg-white closeMobileNav ${!hydrationState ? 'hydrationStateStyle-desktop' : ''} `}
      id="header-mob"
      style={!hydrationState ? hydrationStateStyle : { marginBottom: '-12px' }}
    >
      <header
        className={`relative top-0 w-full ${
          hydrationState ? 'bg-white shadow' : ''
        }`}
      >
        {!hydrationState || !showHeaderOnMobile ? (
          <NavbarSkeleton isMobile={isMobile || isIPadorTablet} />
        ) : null}

        {hydrationState && (
          <NavbarMenu
            hydrationState={hydrationState}
            config={config}
            setOpenState={setOpenState}
            openState={openState}
            previousPath={previousPath}
            setAppliedFilters={setAppliedFilters}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            user={user}
            isGuestUser={isGuestUser}
            setSidebarView={setSidebarView}
            asPath={asPath}
            handleClick={handleClick}
            wishListItemsInCart={wishListItemsInCart}
            openCart={openCart}
            deviceInfo={deviceInfo}
            keywords={keywords}
            accountDropdownConfig={accountDropdownConfig}
            itemsInCart={itemsInCart}
          />
        )}
      </header>

      <nav
        className={`${
          active ? 'navbar-mobile' : 'hidden'
        }  flex flex-wrap w-full nav-overlay lg:hidden`}
      >
        {/*Note that in this div we will use a ternary operator to decide whether or not to display the content of the div  */}
        <div
          className={`${
            active ? '' : 'hidden'
          }   w-full lg:inline-flex lg:flex-grow lg:w-auto bg-white`}
        >
          <div className="flex flex-col items-start w-full lg:inline-flex lg:flex-row lg:ml-auto lg:w-auto lg:items-center lg:h-auto">
            {/* Links */}
            <div className="relative flex items-center justify-between w-full p-4 z-999">
              <div className="">
                <button
                  type="button"
                  className="inline-flex items-center justify-center p-2 -m-2 text-gray-400 rounded-md"
                  onClick={() => {
                    handleClick()
                    setIsOpen(!isOpen)
                    hamburgerMenu(user)
                  }}
                >
                  <Cross className="w-6 h-6 text-black" aria-hidden="true" />
                </button>
              </div>
              <div className="">
                {hydrationState && !isGuestUser && user?.userId ? (
                  <>
                    {user?.firstName != '' ? (
                      <>
                        <Link legacyBehavior href="/my-account" passHref>
                          <a
                            onClick={() => {
                              setIsOpen(!isOpen)
                              userProfileGAEvent(previousPath)
                            }}
                            className="flex items-center text-sm font-semibold leading-none text-orange"
                          >
                            {user?.firstName} {user?.lastName}{' '}
                            <i className="inline-block ml-2 sprite-icon sprite-orange-right-arrow" />
                          </a>
                        </Link>
                      </>
                    ) : (
                      <Link legacyBehavior href="/my-account" passHref>
                        <a
                          onClick={() => {
                            setIsOpen(!isOpen)
                          }}
                          className="flex items-center text-sm font-semibold leading-none text-orange"
                        >
                          Hi{' '}
                          <i className="inline-block ml-2 sprite-icon sprite-orange-right-arrow"></i>
                        </a>
                      </Link>
                    )}
                  </>
                ) : (
                  <>
                    <a
                      onClick={() => {
                        setIsOpen(!isOpen)
                        handleClick()
                        openLoginView(asPath)
                        setSidebarView('LOGIN_VIEW')
                      }}
                      className="text-sm font-semibold text-orange"
                    >
                      Login
                    </a>
                  </>
                )}
              </div>
            </div>
            <NavbarTabView
              config={config}
              handleClick={handleClick}
              setIsOpen={setIsOpen}
              isOpen={isOpen}
              user={user}
              hydrationState={hydrationState}
              setAppliedFilters={setAppliedFilters}
              isGuestUser={isGuestUser}
              setSidebarView={setSidebarView}
              asPath={asPath}
            />
          </div>
        </div>
      </nav>
      {displayAlert ? (
        <div className="block sm:block">
          <AlertRibbon />
        </div>
      ) : null}
    </div>
  )
}

export default NavbarView
